class AssertError extends Error {
}
export function assert(value, message = `value ${String(value)} is falsy`) {
    if (!value) {
        throw new AssertError(message);
    }
}
//# sourceMappingURL=util.js.map